import { createSetIsQueueTaskMessage } from 'calling-global-api/lib/internalEventMessageCreators';
import { postInternalMessage } from '../initialize';
export default function updateIsQueueTaskHandler({
  isQueueTask
}) {
  const message = createSetIsQueueTaskMessage(isQueueTask);
  postInternalMessage(message);
}